import type { ComponentProps } from 'react'
import { useGetPlaceInfo } from 'tripPlanner/hooks/api/chat'
import ChatGooglePlaceWidget from './ChatGooglePlaceWidget'

type Props = Omit<ComponentProps<typeof ChatGooglePlaceWidget>, 'placeInfo' | 'isLoading' | 'isError'>

function ChatGooglePlaceWidgetContainer(props: Props) {
  const { data } = props
  const {
    data: placeInfo,
    isLoading,
    isError,
  } = useGetPlaceInfo(data.googlePlaceId)

  return (
    <ChatGooglePlaceWidget
      {...props}
      placeInfo={placeInfo}
      isLoading={isLoading}
      isError={isError}
    />
  )
}

export default ChatGooglePlaceWidgetContainer
